import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import { getToken } from './utils/auth'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 路由守卫
const whiteList = ['/login']

// 找到当前用户菜单树中的第一个业务菜单路径（登录后的默认落地页）
function findFirstMenuPath(menus) {
  for (const m of menus || []) {
    if (m.type === 'C' && m.path) return m.path
    if (m.children && m.children.length) {
      const p = findFirstMenuPath(m.children)
      if (p) return p
    }
  }
  return ''
}

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      const roles = store.state.user && store.state.user.roles
      if (!roles || roles.length === 0) {
        try {
          await store.dispatch('user/getInfo')
          const menus = store.state.user.menus || []
          const accessedRoutes = await store.dispatch('permission/generateRoutes', menus)
          // 将动态路由注册到 router
          router.addRoutes(accessedRoutes)
          // 访问根路径时重定向到首页菜单（第一个业务菜单）
          if (to.path === '/') {
            next({ path: findFirstMenuPath(menus) || '/dashboard', replace: true })
          } else {
            next({ ...to, replace: true })
          }
        } catch (e) {
          store.dispatch('user/logout')
          next('/login')
        }
      } else {
        // 已加载过菜单：访问根路径同样重定向到首页菜单
        if (to.path === '/') {
          next({ path: findFirstMenuPath(store.state.user.menus) || '/dashboard', replace: true })
        } else {
          next()
        }
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
